import { render, staticRenderFns } from "./DesktopMapViewPage.vue?vue&type=template&id=079f9aed&scoped=true"
import script from "./DesktopMapViewPage.vue?vue&type=script&lang=js"
export * from "./DesktopMapViewPage.vue?vue&type=script&lang=js"
import style0 from "./DesktopMapViewPage.vue?vue&type=style&index=0&id=079f9aed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079f9aed",
  null
  
)

export default component.exports